if (!customElements.get('get-the-look')) {
  class GetTheLook extends HTMLElement {
    constructor() {
      super();
      
      this.cartDrawer = document.querySelector('cart-drawer');
      this.set = [];
      this.funnel = this.dataset.funnel;

      // build add all
      this.querySelectorAll('[data-bundle-variant-group]').forEach((group) => {
        let variantID = group.querySelector('.border-black').dataset.bundleVariantId;
        this.set.push(variantID);
      });

      // Bind option select events
      this.querySelectorAll('[data-bundle-variant]').forEach((variant) => {
        variant.addEventListener('click', this.onVariantSelect.bind(this));
      });

      // add single
      this.querySelectorAll('[data-get-the-look-add-single]').forEach((button) => {
        button.addEventListener('click',this.addSingle.bind(this));
      });

      // add multi
      this.querySelector('[data-get-the-look-add-all]').addEventListener('click', this.addMulti.bind(this));

    }

    /**
     * onVariantSelect
     */
    onVariantSelect(event) {
      let target = event.target;
      if (typeof target.src === 'undefined') {
        target = event.target.querySelector('img');
      }

      let group = target.closest('[data-bundle-variant-group]');
      group.querySelector('.border-black').classList.add('border-black-50');
      group.querySelector('.border-black').classList.remove('border-black');
      target.closest('[data-bundle-variant]').classList.add('border-black');
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] img').src = target.src;
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] img').srcset = target.srcset;
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] span').innerHTML = target.alt;
      
      this.querySelectorAll('[data-bundle-variant-group]').forEach((group) => {
        let variantID = group.querySelector('.border-black').dataset.bundleVariantId;
        this.set.push(variantID);
      });
      this.querySelector('[data-get-the-look-add-all]').dataset.getTheLookAddAll = this.set;
    }

    /**
     * addSingle
     */
    addSingle(event) {
      this.set = [];
      this.isBundle = false;
      this.bundleName = '';
      this.bundleDiscount = 0;
      this.bundleImg = '';
      this.bundleVariantId = '';
      let variantId = event.target.closest('[data-total-bundle]').querySelector('[data-bundle-variant-group] .border-black').dataset.bundleVariantId;
      if (variantId.indexOf(',') > -1) {
        variantId.split(',').forEach((variant) => {
          this.set.push(variant);
        });
        this.isBundle = true;
        this.bundleName = event.target.dataset.bundleName;
        this.bundleDiscount = event.target.dataset.bundleDiscount;
        this.bundleImg = event.target.dataset.bundleImage;
        this.bundleVariantId = event.target.dataset.bundleVariantId;
      } else {
        this.set.push(variantId);
      }
      this.addMulti();
    }

    /**
     * addMulti
     */
    addMulti() {

      if (this.set.length == 0) {
        this.querySelectorAll('[data-bundle-variant-group]').forEach((group) => {
          let variantID = group.querySelector('.border-black').dataset.bundleVariantId;
          this.set.push(variantID);
        });
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
  
      const sectionsToFetch  = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
      ];
  
      let items = [];
      let object = {};
      let properties = {};
      properties._funnel = this.funnel;

      if (this.isBundle) {
        properties.product_bundle = this.bundleName;
        properties._product_bundle_discount = this.bundleDiscount;
        properties._product_bundle_image = this.bundleImg;
        properties._product_bundle_name = this.bundleName;
        properties._product_bundle_variant_id = this.bundleVariantId;
      }

      this.set.forEach((set) => {
        object = {};
        object = {
          quantity: 1,
          id: parseInt(set),
          properties
        }
        items.push(object);
      });
  
      let body = JSON.stringify({
        items: items,
        sections: sectionsToFetch,
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => response.json())
        .then((parsedState) => {
    
          if (this.cartDrawer) {
            this.renderContents(parsedState);
          }

          document.body.classList.remove('product-bundle-is-open');
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.cartDrawer.open();
          this.mainID = this.mainID + 1;
          window.bundleMainId = this.mainID;
          this.set = [];
        });

    }

    renderContents(parsedState) {

      this.getSectionsToRender().forEach((section) => {
        if (section?.selector) {
          const selector = document.querySelector(section.selector);
          if (selector) {
            selector.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.id],
              section.selector
            );
          }
        }
      });

      this.handlePromos();

      this.cartDrawer.querySelectorAll('[data-cart-button-close]').forEach((btn) =>
        btn.addEventListener('click', this.close.bind(this))
      );
  
    }

    handlePromos() {
      if (document.querySelector('[data-product-drawer-promos]')) {
        let promos = document.querySelector('[data-product-drawer-promos]');
        if (promos.dataset && promos.dataset.productDrawerPromos) {
          let promoData = JSON.parse(promos.dataset.productDrawerPromos);
          let enable_promo = promoData.promo_enabled;
  
          if (enable_promo) {
            let promo_variant_id = promoData.promo_variant_id;
            let add_product = promoData.add_product;
  
            // add product
            if (add_product) {
  
              let properties = {};
              properties._promo_product = 'true';
              
              let body = JSON.stringify({
                id: promo_variant_id,
                quantity: 1,
                properties,
                sections: this.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname
              });
              
              fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
                .then((response) => response.json())
                .then((parsedState) => {
                  this.renderContents(parsedState);
                })
                .catch((e) => {
                  console.error(e);
                })
            }
          }
        }
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '[data-cart-drawer]',
        },
        {
          id: 'cart-icon-bubble',
          selector: '[data-cart-icon-bubble]',
        },
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    close() {
      document.body.classList.remove('cart-drawer-is-open');
      document.body.removeEventListener('click', this.onBodyClick);
    }

  }

  window.GetTheLook = GetTheLook;
  customElements.define('get-the-look', GetTheLook);
}
